import 'jquery';
export class Tooltip {

    constructor($) {
        var that = this;

        $(document).on('click.unify.tooltip-toggle', function (e) {
            var $target = $(e.target);
            var $tooltipButton = $target.closest('[data-toggle~=unify-tooltip]');

            if ($tooltipButton.length > 0) {

                that._toggleTooltip($tooltipButton);

                if ($tooltipButton.is('a')) {
                    e.preventDefault();
                }

            } else {
                that._hideTooltips();
            }
        });
    }

    /**
     * Adds the html data attributes to the tooltip button, if not already there.
     *
     * This is normally run in an onclick listener by users.
     * It works because it runs before the click listener above, since the above listener is bound to the document 
     * and click events always bubble outward in the dom.
     * @param target The button HTMLElement 
     * @param tooltipSelector The full CSS selector string for selecting the tooltip
     */
    showOnElement(target, tooltipSelector) {
        var $tooltip = $(tooltipSelector),
            $target = $(target);

        if (target && $tooltip[0]) {
            if (!$target.is('[data-toggle~=unify-tooltip]')) {
                $target.attr('data-toggle', 'unify-tooltip');
            }
            if (!$target.is('[data-target~="' + tooltipSelector + '"]')) {
                $target.attr('data-target', tooltipSelector);
            }
        }
    }

    _hideTooltips() {
        /*
         * Hide all tooltips if not clicking on a tooltip button
         */
        $('.unify-tooltip').removeClass('unify-tooltip--visible');
        $(window).off('resize.unify.tooltip');
    }

    /**
     * Hides or show tooltips depending on if a tooltip button was clicked, and if it's tooltip was visible or not.
     */
    _toggleTooltip($tooltipButton) {

        let $tooltip = $($tooltipButton.attr('data-target'));

        if ($tooltip.hasClass('unify-tooltip--visible')) {
            $tooltip.removeClass('unify-tooltip--visible');
        } else {
            this._show('right', $tooltipButton[0], $tooltip);
        }
    }

    _show(direction, target, $tooltip) {
        var that = this;

        $tooltip.addClass('unify-tooltip--visible');

        this._positionTooltip(direction, target, $tooltip);

        $(window).on('resize.unify.tooltip', function () {
            that._positionTooltip(direction, target, $tooltip);
        });

    }

    _positionTooltip(direction, target, $tooltip) {

        var $target = $(target),
            targetGlobalOffset = this._getOffset('global', target),
            targetLocalOffset = this._getOffset('local', target);

        var targetHeight = $target.outerHeight(),
            targetWidth = $target.outerWidth();

        var tooltipWidth = $tooltip.outerWidth(),
            tooltipGlobalLeft,
            tooltipLocalLeft,
            tooltipLocalTop,
            tooltipFitsOnScreen;

        /*
             d      /\
             e     /  \
             p    /    \
             t   /      \
             h  /        \___________
                                    |
               <- width -><- inset ->
        */
        var arrowDepth = 14.14;
        var arrowInset = 21; // 24px in the CSS, but since the arrow is rotated its actually a bit smaller
        var arrowWidth = 28.28;

        /* How much to offset the tooltips default distance from target. */
        var tooltipDistanceAdjustment = -2; /* -2 will make it so the arrow points 2px inside target, 0 would point at the edge of target */

        /*
         * Position tooltip to the right of target
         */
        if ('right' === direction) {
            tooltipGlobalLeft = targetGlobalOffset.left + targetWidth + arrowDepth + tooltipDistanceAdjustment;
            tooltipLocalLeft = targetLocalOffset.left + targetWidth + arrowDepth + tooltipDistanceAdjustment;
            tooltipLocalTop = targetLocalOffset.top - (arrowInset + arrowWidth / 2) + targetHeight / 2;

            tooltipFitsOnScreen = tooltipGlobalLeft + tooltipWidth <= $(window).width();

            if (tooltipFitsOnScreen) {

                $tooltip.css('left', tooltipLocalLeft)
                    .css('top', tooltipLocalTop)
                    .children('.unify-tooltip__arrow')
                    .removeClass('unify-tooltip__arrow--top-right')
                    .addClass('unify-tooltip__arrow--left-top');

                return;
            }
        }

        /*
         * Fallback: Position tooltip below target
         */
        tooltipGlobalLeft = targetGlobalOffset.left - tooltipWidth + targetWidth / 2 + arrowInset + arrowWidth / 2;
        tooltipLocalLeft = targetLocalOffset.left - tooltipWidth + arrowInset + arrowWidth / 2 + targetWidth / 2;
        tooltipLocalTop = targetLocalOffset.top + targetHeight + arrowDepth + tooltipDistanceAdjustment;

        tooltipFitsOnScreen = tooltipGlobalLeft > 0 && (tooltipGlobalLeft + tooltipWidth) < $(window).width() - 1;

        if (tooltipFitsOnScreen) {
            $tooltip.css('left', tooltipLocalLeft)
                .css('top', tooltipLocalTop)
                .children('.unify-tooltip__arrow')
                .removeClass('unify-tooltip__arrow--left-top')
                .addClass('unify-tooltip__arrow--top-right');
        } else {
            /* For small windows:
             * Force the tooltip to fit inside the window by making it as wide as the window
             * and placing it in the leftmost corner of the window */

            arrowInset = $target.offset().left + targetWidth / 2 - arrowWidth / 2;

            $tooltip.css('width', $(window).width())
                .offset({ left: 0 })
                .css('top', tooltipLocalTop)
                .children('.unify-tooltip__arrow')
                .removeClass('unify-tooltip__arrow--left-top')
                .addClass('unify-tooltip__arrow--top-right')
                .offset({ left: arrowInset });

        }
    }

    _getOffset(scope, target) {
        var $target = $(target);
        var offset;

        if ('local' === scope) {
            offset = $target.position();
        } else {
            // assume global scope
            offset = $target.offset();
        }

        var marginTop = parseInt($target.css('margin-top'));
        var marginLeft = parseInt($target.css('margin-left'));

        offset.left += isNaN(marginLeft) ? 0 : marginLeft;
        offset.top += isNaN(marginTop) ? 0 : marginTop;

        return offset;
    }
}
